import { render, staticRenderFns } from "./ScorecardList.vue?vue&type=template&id=5eb475a3&"
import script from "./ScorecardList.vue?vue&type=script&lang=ts&"
export * from "./ScorecardList.vue?vue&type=script&lang=ts&"
import style0 from "./ScorecardList.vue?vue&type=style&index=0&id=5eb475a3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports